var map = {
	"./logo-cdp.svg": "afd7",
	"./logo-cee-cdp.svg": "6aaa",
	"./logo-cee.svg": "00e4",
	"./logo-ecoptz.svg": "843c",
	"./logo-mpr-copro.svg": "605d1",
	"./logo-mpr-opacity.svg": "623c",
	"./logo-mpr-serenite.svg": "4379",
	"./logo-mpr.svg": "6e3d",
	"./logo-tva55.svg": "4ff7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "54ba";